import { decamelize } from 'humps';
const keysWillNotBeConverted = ['useBase64', 'captchaConfig'];
export const decamelizeKey = (key) => key.substr(0, 2) === '__' || ~keysWillNotBeConverted.indexOf(key)
    ? key
    : decamelize(key);
export const decamelizeRpcKeys = (payload) => {
    const transformNotRequired = !payload || typeof payload !== 'object' || Array.isArray(payload);
    if (transformNotRequired) {
        return payload;
    }
    return Object.keys(payload).reduce((acc, key) => ({
        ...acc,
        [decamelizeKey(key)]: decamelizeRpcKeys(payload[key])
    }), {});
};
